// extracted by mini-css-extract-plugin
export default {"menuItem":"y5XksE","light":"Dabn_E","button":"kr9hC1","navigation":"UmEsNw","phone":"GGHgh8","email":"PyAY1T","address":"WoMY4m","socialLinks":"tawVn5"};